import { UIKitIcon } from '../icon';

export const shareIcon: UIKitIcon = {
  name: 'share',
  // tslint:disable-next-line: max-line-length
  data: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><polyline points="21 14 24 14 24 26 8 26 8 14 11 14" style="fill:'
  + 'inherit;stroke:inherit;stroke-linecap:round;stroke-linejoin:round"/><line x1="16" y1="16" x2="16" y2="6" style="fill:inherit;'
  + 'stroke:inherit;stroke-linecap:round;stroke-linejoin:round"/><line x1="20" y1="10" x2="16" y2="6" style="fill:inherit;stroke:inherit;'
  + 'stroke-linecap:round;stroke-linejoin:round"/><line x1="12" y1="10" x2="16" y2="6" style="fill:inherit;stroke:inherit;stroke-linecap:'
  + 'round;stroke-linejoin:round"/></svg>',
};
